import { TYPES } from '@/engine/ioc';
import { inject, injectable } from 'inversify';
import { EToastKind, type ToastNotificationsController } from '@/components/toastNotifications/ToastNotifications.controller';
import type { INotificationsCenter } from './interfaces';

@injectable()
export class NotificationsCenter implements INotificationsCenter {
  private readonly _toastNotificationsController: ToastNotificationsController;

  public constructor(
    @inject(TYPES.ToastNotificationsController) toastNotificationsController: ToastNotificationsController
  ) {
    this._toastNotificationsController = toastNotificationsController;
  }

  public onError(message: string): void {
    this._toastNotificationsController.publish(message, {
      kind: EToastKind.Error
    });
  }

  public onSuccess(message: string): void {
    this._toastNotificationsController.publish(message, {
      kind: EToastKind.Success
    });
  }

  public onWarning(message: string): void {
    this._toastNotificationsController.publish(message, {
      kind: EToastKind.Warning
    });
  }

  public onInfo(message: string): void {
    this._toastNotificationsController.publish(message, {
      kind: EToastKind.Info
    });
  }
}
